export default "__VITE_ASSET__WA7ytRp$__"